import ListItemText from '@mui/material/ListItemText';
import Tooltip from "@mui/material/Tooltip";
import { useRef, useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

function TruncatedText({ text, tooltipProps = {} }) {
    const textElementRef = useRef(null);
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const checkIfTruncated = () => {
            if (textElementRef.current) {
                const { offsetWidth, scrollWidth } = textElementRef.current;
                setIsTextTruncated(scrollWidth > offsetWidth);
            }
        };

        const debouncedCheck = debounce(checkIfTruncated, 100);
        checkIfTruncated();
        window.addEventListener('resize', debouncedCheck);

        return () => {
            window.removeEventListener('resize', debouncedCheck);
            debouncedCheck.cancel();
        };
    }, [text]);

    const textElement = (
        <div
            ref={textElementRef}
            style={{
                width: '100%',  // Ensure the div takes full width
                minWidth: 0,    // Allow shrinking
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block' // Change from flex to block
            }}
            onMouseEnter={() => {
                setIsHovered(true);
            }}
            onMouseLeave={() => {
                setIsHovered(false);
            }}
        >
            {text}
        </div>
    );

    return isTextTruncated ? (
        <Tooltip
            placement="right"
            enterDelay={500}
            arrow
            {...tooltipProps}
            open={isHovered}
            title={text}
        >
            {textElement}
        </Tooltip>
    ) : textElement;
}

export default TruncatedText;